import React from 'react';

interface TableColumn {
    label: string;
    align?: 'left' | 'right';
}

interface TableHeaderProps {
    columns: TableColumn[];
    variant?: 'default' | 'dark' | 'glass';
    size?: 'sm' | 'lg';
    className?: string;
}

const VARIANT_BG: Record<string, string> = {
    default: 'bg-gray-50 dark:bg-neutral-700',
    dark: 'bg-gray-50 dark:bg-neutral-900',
    glass: 'bg-white/40 dark:bg-white/5',
};

const TableHeader: React.FC<TableHeaderProps> = ({
    columns,
    variant = 'default',
    size = 'lg',
    className = '',
}) => {
    const px = size === 'sm' ? 'px-4' : 'px-6';
    const bg = VARIANT_BG[variant];

    return (
        <thead className={`${bg} ${className}`}>
            <tr>
                {columns.map((col, i) => (
                    <th
                        key={i}
                        className={`${px} py-3 text-${col.align ?? 'left'} text-xs font-medium tracking-wider text-gray-500 uppercase dark:text-neutral-400`}
                    >
                        {col.label}
                    </th>
                ))}
            </tr>
        </thead>
    );
};

export default TableHeader;
